module.exports = __webpack_public_path__ + "static/media/Ula_Pniewy.2092652f.png";